import { render, staticRenderFns } from "./FDProductNIB.vue?vue&type=template&id=c573cfec&"
import script from "./FDProductNIB.vue?vue&type=script&lang=js&"
export * from "./FDProductNIB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports